require('./RAProjectionChartTooltip.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
// @ components
const RAOneLineSymbolAmount = require('components/RAComponents/commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
// @ utilities
import { FormattedText } from 'core/i18n';
// @ constants
const {
    EURO_SYMBOL,
    RA_PROJECTION_CHART_UP_KEY,
    RA_PROJECTION_CHART_MID_KEY,
    RA_PROJECTION_CHART_LOW_KEY,
} = require('constants/RAConstants');

class RAProjectionChartTooltip extends React.Component {
    getCurrentValues() {
        return this.props.payload[0]?.payload;
    }

    render() {
        const { active } = this.props;
        let content = null;

        if (active) {
            const values = this.getCurrentValues();

            content = (
                <ul className="ra-projection-chart-tooltip">
                    <li className="ra-projection-chart-tooltip--light-blue">
                        <div className="ra-projection-chart-tooltip__wrapper-legend">
                            <span className="ra-projection-chart-tooltip__legend" />
                        </div>
                        <div className="ra-projection-chart-tooltip__wrapper-amount-description">
                            <span className="ra-projection-chart-tooltip__amount">
                                <RAOneLineSymbolAmount
                                    amountObject={{
                                        currency: EURO_SYMBOL,
                                        amount: values && values[RA_PROJECTION_CHART_UP_KEY],
                                    }}
                                    trimDecimals={true}
                                />
                            </span>
                            <span className="ra-projection-chart-tooltip__description">
                                <FormattedText value="rentabilityGraph-maximumLabel" />
                            </span>
                        </div>
                    </li>
                    <li className="ra-projection-chart-tooltip--default">
                        <div className="ra-projection-chart-tooltip__wrapper-legend">
                            <span className="ra-projection-chart-tooltip__legend" />
                        </div>
                        <div className="ra-projection-chart-tooltip__wrapper-amount-description">
                            <span className="ra-projection-chart-tooltip__amount">
                                <RAOneLineSymbolAmount
                                    amountObject={{
                                        currency: EURO_SYMBOL,
                                        amount: values[RA_PROJECTION_CHART_MID_KEY],
                                    }}
                                    trimDecimals={true}
                                />
                            </span>
                            <span className="ra-projection-chart-tooltip__description">
                                <FormattedText value="rentabilityGraph-expectedLabel" />
                            </span>
                        </div>
                    </li>
                    <li className="ra-projection-chart-tooltip--grey">
                        <div className="ra-projection-chart-tooltip__wrapper-legend">
                            <span className="ra-projection-chart-tooltip__legend" />
                        </div>
                        <div className="ra-projection-chart-tooltip__wrapper-amount-description">
                            <span className="ra-projection-chart-tooltip__amount">
                                <RAOneLineSymbolAmount
                                    amountObject={{
                                        currency: EURO_SYMBOL,
                                        amount: values[RA_PROJECTION_CHART_LOW_KEY],
                                    }}
                                    trimDecimals={true}
                                />
                            </span>
                            <span className="ra-projection-chart-tooltip__description">
                                <FormattedText value="rentabilityGraph-minimumLabel" />
                            </span>
                        </div>
                    </li>
                </ul>
            );
        }

        return content;
    }
}

RAProjectionChartTooltip.propTypes = {
    active: PropTypes.boolean,
    payload: PropTypes.array,
};
RAProjectionChartTooltip.defaultProps = {
    active: false,
    payload: [],
};

module.exports = RAProjectionChartTooltip;
